import React  from 'react';
import Accounts from '../../../common/report/transaction/Accounts';

function AdminAccounts(){
  return <Accounts/>
}

export default AdminAccounts;